import { useTranslation } from "react-i18next"
import { Navigate, useNavigate } from "react-router-dom"
import { observer } from "mobx-react-lite"
import { InovaLogoIcon, ScreenContainer, SignInButton, SpinnerOverlay, Text } from "../components"
import AuthStore from "../stores/AuthStore"

export const LoginPage = observer(() => {
	const { t } = useTranslation()
	const navigate = useNavigate()

	if (AuthStore.user) {
		return <Navigate to="/" />
	}

	return (
		<ScreenContainer>
			{AuthStore.isLoading && <SpinnerOverlay />}

			<div className="flex h-[90vh] flex-col items-center justify-between">
				<div className="flex flex-1 items-center justify-center">
					<InovaLogoIcon size={150} />
				</div>

				<div className="flex max-w-[80%] flex-col items-center justify-center gap-[24px] justify-self-end">
					<div className="text-center">
						<Text>{t("landing.login")}</Text>
					</div>

					<SignInButton
						onClick={async () => {
							await AuthStore.signIn()
							navigate("/")
						}}
					/>
				</div>
			</div>
		</ScreenContainer>
	)
})
